// extracted by mini-css-extract-plugin
module.exports = {"Page":"Page_Page__3evaB","centered":"Page_centered__39wq-","topBarPadding":"Page_topBarPadding__3QMpW","bottomBarPadding":"Page_bottomBarPadding__1OJzc"};